import React, {useCallback, useState} from 'react'

const SlateEditorContext = React.createContext({})

export const SlateEditorProvider = ({ value, children }) => {
  const [values, setValues] = useState({})

  const set = useCallback((name, val) => {
    setValues((prev) => ({ ...(prev ?? {}), [name]: val }))
  }, [])

  return (
    <SlateEditorContext.Provider
      value={{
        ...value,
        set,
        values,
        setValues,
      }}>
      {children}
    </SlateEditorContext.Provider>
  )
}

export default SlateEditorContext
